var Favorite = React.createClass({
  requestPending: false,
  feedbackTimeout: null,
  getInitialState() {
    return {
      favorite: {}
    };
  },
  componentDidMount() {
    let url = Config.contextPath + "/controller/find/myfavorites/?solutionID=" + RA.ViewKB.solution.id;

    $.get(url)
      .done(r => {
        let favorite = r;
        this.setState({favorite: favorite});

        if (favorite.id && (favorite.description != RA.ViewKB.solution.title)) {
          this.updateFavorite();
        }
      });
  },
  favoriteClicked() {
    if (this.state.favorite.id) {
      this.removeFavorite();
    } else {
      this.addFavorite();
      RA.ViewKB.logAction("ADDFAVORITES");
    }
  },
  addFavorite() {
    if (this.requestPending) return;

    let url = Config.contextPath + "/controller/add/myfavorites/";

	let solutionUrl = window.location.href.split("?")[0] + "?solutionid=" + RA.ViewKB.solution.id;

    let data = {
      solutionID: RA.ViewKB.solution.id,
      description: RA.ViewKB.solution.title,
      url: solutionUrl,
      SToken: Config.csrf.value
    };

    this.requestPending = true;
    $.post(url, data)
      .done(r => {
        this.requestPending = false;

        if (r.success) {
          let $feedback = $(this.refs.feedback);

          this.setState({favorite: r.favorite});
          $feedback.fadeIn();
          this.setFeedbackTimeout();
        }
      });
  },
  updateFavorite() {
    let url = Config.contextPath + "/controller/update/myfavorites/" + this.state.favorite.id;
    let data = {
      solutionID: RA.ViewKB.solution.id,
      description: RA.ViewKB.solution.title,
      url: window.location.href,
      SToken: Config.csrf.value
    };

    $.post(url, data);
  },
  removeFavorite() {
    if (this.requestPending) return;

    let url = Config.contextPath + "/controller/delete/myfavorites/" + this.state.favorite.id;

    let data = {
     SToken: Config.csrf.value
    };

    this.requestPending = true;
    $.post(url, data)
      .done(r => {
        this.requestPending = false;
        this.setState({favorite: {}});
      });
  },
  clearFeedbackTimeout() {
    if (this.feedbackTimeout) {
      clearTimeout(this.feedbackTimeout);
      this.feedbackTimeout = null;
    }
  },
  setFeedbackTimeout() {
    this.feedbackTimeout = setTimeout(() => {
      let $feedback = $(this.refs.feedback);
      $feedback.fadeOut();
    }, 2000);
  },

  render() {
    let favUrl = `${Config.contextPath}/${Config.portalInterface}/?tabname=account#favorites`;
    let isFavorite = this.state.favorite.id != undefined;
    let className = classNames(
      "glyphicon actions-list__icon",
      (isFavorite ? "glyphicon-star" : "glyphicon-star-empty")
    );

	let linkClass = ``;
	if (isSimplifiedSocialLayout) {
		favUrl = `#`;
		linkClass = `disguiseFavoriteLink`;
	}

    return (
      <div>
        <a href="#" onClick={this.favoriteClicked} className="actions-list__link -favorite" title={Labels.getLabel("Favorite")}>
          <span className={className}></span>&nbsp;
          <span>{Labels.getLabel("Favorite")}</span>
        </a>
        <div className="actions-list__feedback" ref="feedback" onMouseOver={this.clearFeedbackTimeout} onMouseOut={this.setFeedbackTimeout}>
          <span>{Labels.getLabel("Solution added to") + " "}<a href={favUrl} className={linkClass}>{Labels.getLabel("My Favorites")}</a></span>
        </div>
      </div>
    );
  }
});